<template>
	<formSelect
		v-model="inputCountryCode"
		:orderByLoco="orderByLoco"
		@change="changeCountry($event)"
		:hasError="hasError"
		:options="countryStringsList"
		:stringSelector="stringSelector"
		:placeHolder="$t('create-account.select-country')"
		:filterable="true"
		:disabled="disabled"
		labelText="">
	</formSelect>
</template>

<script>
import formSelect from './form-select';

export default {
	name: 'countrySelect',
	model: {
		prop: 'code',
		event: 'change'
	},
	props: {
		stringSelector: {
			type: String,
			default: null,
			required: true,
			note: 'For localize support, it must be defined'
		},
		hasError: {
			type: Boolean,
			default: false,
			note: 'Error handling'
		},
		code: {
			type: String,
			default: null,
			note: 'Country code setting'
		},
		countryCodesList: {
			type: Array,
			default() {
				return [];
			},
			note: 'Country list code.'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Disable when it needed'
		},
		orderByLoco: {
			type: Boolean,
			default: true,
			note: 'Unified countries have unique ordering'
		},
	},
	components: {
		formSelect
	},
	data() {
		return {
			inputCountryCode: this.code,
		};
	},
	computed: {
		countryStringsList() {
			return this.countryCodesList.map(
				alpha2 => ({
					label: `${alpha2}`,
					value: alpha2
				})
			);
		},
	},
	watch: {
		code(newValue) {
			this.inputCountryCode = newValue;
		}
	},
	methods: {
		changeCountry(newValue) {
			this.inputCountryCode = newValue;
			this.$emit('change', this.inputCountryCode);
		},
	}
};
</script>

<style lang="less">
#createAccount,
	#healupTap {
		.btn-group {
			.caret {
				top: 23px ;
			}
		}
	}
</style>
